module.exports = __webpack_public_path__ + "img/color-calc-icon.359d7f7e.svg";